import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {RouteDataService} from "../shared/services/route-data/route-data.service";
import {RouteData} from "../shared/services/route-data/route-data";
import {combineLatest, Observable, Subject, Subscription} from "rxjs";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Website} from "../websites/website/website";
import {WebsiteService} from '../websites/website.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import hostingFeatures from '../components/common/informative-dialog/features/hosting-add-on-features.json';
import {distinctUntilChanged, filter, first, switchMap, takeUntil} from 'rxjs/operators';
import {DialogService} from "../../ng2-bootstrap-modal/dialog.service";
import {User} from "../user/user";
import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionIds,
  UserSubscriptionType
} from "../user/user-subscription";
import {GoogleAnalyticsService} from "../shared/services/google-analytics/google-analytics.service";
import {ActivityStatus, IActivity} from '../activities/activity';
import {Utils} from '../shared/utils/utils';
import {HostingService} from "../websites/website/hosting/hosting.service";
import {GlobalEvent} from "../shared/services/global-event-dispatcher/global-event";
import {GlobalEventDispatcherService} from "../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {CookieService} from "ngx-cookie";
import {MobileAvailableComponent} from "../shared/components/dialogs/mobile-available/mobile-available.component";
import {UserService} from "../user/user.service";
import {TypeFormAnswers} from "../add-website/typeFormAnswers";
import {clientRoles} from "../user/user-roles-actions";
import {ActionEmitterService} from "../shared/services/action-emitter.service";
import {RechargeComponent} from "../shared/components/dialogs/recharge-dialog/recharge.component";
import {
  NotificationDialogComponent
} from "../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../shared/utils/text-utils";
import {PaymentDialogComponent} from "../workspace/billing/payment-dialog/payment-dialog.component";
import {
  BoosterPluginDownloadDialogComponent
} from "../websites/website/booster/dialogs/booster-plugin-download-dialog/booster-plugin-download-dialog.component";
import {DbModalService} from "../modules/modal/modal";
import {Config} from "../config/config";
import {Product} from "../websites/website/product";
import {TypeUtils} from "../shared/utils/type-utils";
import {
  UpdateBoosterPluginComponent
} from "../websites/website/booster/dialogs/update-booster-plugin/update-plugin.component";
import {InformativeDialogComponent} from "../components/common/informative-dialog/informative-dialog.component";
import {BoosterPage} from "../websites/website/booster/mappers/booster-page";
import {PerformanceService} from "../websites/website/performance/performance.service";
import {WebsiteSidebarItem} from "./website-sidebar-list/website-sidebar-item.model";
import {WebsiteSidebarSubMenu} from "./website-sidebar-list/website-sidebar-sub-menu/website-sidebar-sub-menu.model";
import {
  WebsiteSidebarSubMenuDirector
} from "./website-sidebar-list/website-sidebar-sub-menu/website-sidebar-sub-menu.director";
import {
  WebsiteSidebarSimpleItemDirector
} from "./website-sidebar-list/website-sidebar-simple-item/website-sidebar-simple-item.director";
import {
  IWebsiteSidebarList,
  WebsiteSidebarListFactory,
  WebsiteSidebarListFactoryType
} from "./website-sidebar-list/website-sidebar-list";
import {HostingDomainData} from "../websites/website/hosting/domains/hostingDomainData";
import {SidebarNavigationService} from "../shared/services/navigation/sidebar-navigation.service";
import {BuilderSectionsInteractionService} from "../builder-v2/builder-sections-interaction.service";

@Component({
    selector: 'db-website-sidebar',
    templateUrl: './website-sidebar.component.html',
    styleUrls: ['./website-sidebar.component.scss'],
    standalone: false
})
export class WebsiteSidebarComponent implements OnInit, OnDestroy {

  @Input() toggleSidebar: boolean;
  @Input() hasBanner?: boolean = false;
  @Output() onToggleClick = new EventEmitter<boolean>();
  @ViewChild('advancedMenuRef', {static: false}) advancedMenuRef: ElementRef;
  public website: Website;
  public websiteSettings: any;
  public user: User;
  public boosterPlugin: Product;
  public userSubscription: UserSubscription;
  public disableCopyWebsite: boolean = false;
  public routeData: RouteData;
  public userSubscriptionTypes = UserSubscriptionType;
  public toggledTour$: Observable<boolean>;
  public parentWebsite: Website;
  public networkSubSites: Website[];
  public sidebarItems: IWebsiteSidebarList;
  public advancedSidebarItems: IWebsiteSidebarList;
  public showAdvanced: boolean = false;
  public showTour: boolean = false;
  public userSubscriptionIds = UserSubscriptionIds;
  public isMobile: boolean;
  public extraMobile: boolean;
  public routerLink: string;
  public typeFormAnswers = TypeFormAnswers;
  public agencyOrFreelancer: boolean;
  public seenUpdateDialog: boolean;
  public hostingAddOnFeatures = hostingFeatures;
  public hostedWebsiteCount: any;
  public UserSubscriptionCategory = UserSubscriptionCategory;
  public showPercentOffer: boolean;
  public fromGallery: boolean;
  public redirectionCompleted: boolean = false;
  public passwordProtection: any;
  public toggled = false;
  public domains: HostingDomainData[];
  public primaryChanged: boolean;
  public hostedWebsite: Website;
  public hasPayments: boolean = true;
  public woocommercePlugin: Product;
  public seoPlugin: Product;
  public userRole: any;
  companyName: string = '';
  private userLocalStorage: any;
  private _prevWebsiteId: number = null;
  private _websiteSubscriptions: Subscription[];
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  private currentWorkspaceId: any;

  constructor(
    public sidebarNavigationService: SidebarNavigationService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _routeDataService: RouteDataService,
    private _cookieService: CookieService,
    private _websiteService: WebsiteService,
    private _hostingService: HostingService,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _globalEventDispatcher: GlobalEventDispatcherService,
    private _builderSectionsInteractionService: BuilderSectionsInteractionService,
    private _dialogService: DialogService,
    private _modalService: DbModalService,
    private _userService: UserService,
    private _dbModalService: DbModalService,
    private _actionEmitterService: ActionEmitterService,
    private _performanceService: PerformanceService
  ) {
  }

  ngOnInit() {
      this._getCompanyInfo();
    this.isMobile = window.innerWidth <= 991;
    this.extraMobile = window.innerWidth < 670;
    this.routerLink = this._router.url;
    this.routeData = this._routeDataService.getCurrentRouteData();
    this.initData();
    this.toggledTour$ = this._store.select(fromStore.getTourSectionToggled)
      .pipe(
        takeUntil(this._destroyStream$)
      );
    this._globalEventDispatcher.dispatchEvent(GlobalEvent.hostedWebsitePages, this.website);
    this.checkAvailability();
    this.addEventHandlers();

    this._checkAndExpandAdvancedSection();
    this._checkAndExpandDropdowns();

    this._store.select(fromStore.getMigrationOngoingActivity)
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe((migrationActivity): void => {
        if (!migrationActivity) {
          return;
        }
        switch (migrationActivity.status) {
          case ActivityStatus.DONE:
          case ActivityStatus.FAILED:
            this.disableCopyWebsite = false;
            break;

          default:
            this.disableCopyWebsite = true;
            break;
        }
      });

    if (!this._dialogService.hasOpenedDialog() && !this._modalService.hasOpenModals()) {
      this.showHostingFeaturesDialog();
    }
/*    if (!this._dialogService.hasOpenedDialog() && !this._modalService.hasOpenModals()) {
      this._boosterNpsDialog();
    }*/
    this._showPercentOffer();

    if (!this._dialogService.hasOpenedDialog() && !this._modalService.hasOpenModals()) {
      !this.seenUpdateDialog && this.boosterPlugin && this.boosterPlugin.active && this._checkBoosterPluginUpdateAvailable();
    }
  }

    private _getCompanyInfo(): void {
        this._builderSectionsInteractionService.companyInfo
            .pipe(
                filter(companyInfo => !!companyInfo),
                takeUntil(this._destroyStream$),
                first()
            )
            .subscribe(companyInfo => {
                this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
            });
    }

  public showHostingFeaturesDialog(): void {
    if (this.userSubscription && this.user
      && this.userSubscription.boosterProClient && (this.website && this.website.connectedFrom === 'speed_optimizer')
      && (this.userSubscription.plan && !this.userSubscription.plan.additionalDomainCount)
    ) {
      const hostingFeaturesDialogOpened = localStorage.getItem('hostingFeaturesDialogOpened' + this.user.id);
      if (hostingFeaturesDialogOpened === null) {
        localStorage.setItem('hostingFeaturesDialogOpened' + this.user.id, 'true');
        this._hostingAddOnDialogShow();
      }
    }
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
    this.removeWebsiteSubscriptions();
  }

  public optimizeWebsite(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Optimize more websites - sidebar',
      eventLabel: 'Speed Booster',
      websiteId: this.website.id
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);

    if (this.userSubscription && this.userSubscription.domainsPermission && !this.userSubscription.domainsPermission.canConnectSpeedWebsite) {
      this.showExceededDialog();
      return;
    }
/*    this.showOptimizeOnlyDialog();*/
  }

  public sendAnalyticsEvent() {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: "MoveTo10Web Page visit",
      eventLabel: 'Menu item click',
      websiteId: this.website && this.website.id
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  public checkAvailability(): void {
    const todayDate = new Date().getFullYear() + '-' + ("0" + (new Date().getMonth() + 1)).slice(-2) + '-' + ("0" + new Date().getDate()).slice(-2);
    let checked;
    try {
      checked = localStorage.getItem('dbCheckAvailability') ? JSON.parse(localStorage.getItem('dbCheckAvailability')) : {};
    } catch (e) {
      checked = {[this.website?.id]: localStorage.getItem('dbCheckAvailability')};
    }
    if (this.website?.domain_hash && checked[this.website.id] !== todayDate) {
      checked[this.website.id] = todayDate;
      localStorage.setItem('dbCheckAvailability', JSON.stringify(checked));
      this._hostingService.checkWebsiteAvailability(this.website.id);
    }
  }

  public mobileAvailability(routerLink) {
    if (routerLink) {
      if (window.innerWidth <= 991 && this.user && this.user.subscriptionId === UserSubscriptionIds.TRIAL
        && ['/hosting/resource-usage', '/hosting/logs', '/builder', '/plugins', '/themes', '/backup', '/security', 'seo', '/seo/seo-overview', '/seo/search-analytics', '/image-optimizer'].includes(routerLink)) {
        this._dialogService.addDialog(MobileAvailableComponent, {
          header: 'Currently Available<div class="db-icon-wrap">on Desktop <img src="assets/images/emojis/wink.png" alt=""/></div>',
          message: 'We’ll have the mobile version really soon!<br/> Until then, please use the Desktop version<br/>to access this page.'
        });
      } else if (['/white-label', '/referral-system/program', 'referral-system/program'].includes(routerLink)) {
        this._router.navigate([routerLink]);
      } else {
        this._router.navigate(['websites/' + this.website.id + routerLink]);
      }
    }
  }

  public sendRedirectEcommerceEvents(name: string): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Ecommerce Menu Item click',
      eventLabel: TextUtils.getText(name)
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  /**
   * Toggles the advanced section with auto-focus and auto-scroll functionality
   */
  public toggleAdvancedSection(): void {
    const wasShown = this.showAdvanced;
    this.showAdvanced = !this.showAdvanced;

    if (!wasShown && this.showAdvanced) {
      setTimeout(() => {
        if (this.advancedMenuRef && this.advancedMenuRef.nativeElement) {
          this.advancedMenuRef.nativeElement.focus();

          const activeSubmenuItem = this.findActiveSubmenuItem();
          if (activeSubmenuItem) {
            activeSubmenuItem.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            });
          } else {
            this.advancedMenuRef.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest'
            });
          }
        }
      }, 150);
    }
  }

/*  private _boosterNpsDialog(): void {
    if (!Config.photoGalleryPluginIds.includes(this.user?.connectedFromProductId.toString()) && (this.userSubscription && (this.userSubscription.boosterProClient || this.userSubscription.trialBoosterClient))
      && +Utils.getDaysDiffFromToday(this.user.createdAt, false) > 7 && window.innerWidth > 991) {
      this._store.select(fromStore.getWebsites)
        .pipe(
          first(websites => !!websites)
        )
        .subscribe(websites => {
          const boosterWebsites = websites.filter(website => website && website.connectedFrom === 'speed_optimizer' && website.isActive);
          if (boosterWebsites.length) {
            const firstWebsite = boosterWebsites[0];
            if (this._getScores(firstWebsite.score)) {
              this._getBoosterNpsData(firstWebsite.id);
            }
          }
        });
    }
  }*/

  private _getScores(scores) {
    let significantDesktopScoreChange = false,
      significantMobileScoreChange = false;
    if (scores && scores.currentScore && scores.originalScore) {
      const currentScore = scores.currentScore;
      const originalScore = scores.originalScore;
      if (currentScore.desktopScore && currentScore.mobileScore
        && originalScore.desktopScore && originalScore.mobileScore
        && currentScore.desktopScore !== 101 && currentScore.mobileScore !== 101
        && originalScore.desktopScore !== 101 && originalScore.mobileScore !== 101) {
        significantDesktopScoreChange = (Math.log((150 - (originalScore.desktopScore)) / (150 - (currentScore.desktopScore))) / Math.log((150 - (originalScore.desktopScore)) / 50)) > 0.45; // 0.45 coefficient
        significantMobileScoreChange = (Math.log((150 - (originalScore.mobileScore)) / (150 - (currentScore.mobileScore))) / Math.log((150 - (originalScore.mobileScore)) / 50)) > 0.45; // 0.45 coefficient
      }
    }
    return significantDesktopScoreChange && significantMobileScoreChange;
  }

  private _getBoosterNpsData(websiteId) {
    this._performanceService.getBoosterNpsData(websiteId)
      .pipe(
        first(response => !!response, null),
      )
      .subscribe(response => {
        if (response.success) {
          if (!response.data.nps) {
            this._getCustomPages(websiteId);
          }
        }
      });
  }

  private _getCustomPages(websiteId): void {
    if (this.userSubscription.paidClient) {
      this._store.select(fromStore.getWebsiteBoosterCustomPages(websiteId))
        .pipe(
          distinctUntilChanged((oldPages: BoosterPage[], newPages: BoosterPage[]) => oldPages && newPages && oldPages.length === newPages.length),
          takeUntil(this._destroyStream$)
        )
        .subscribe(pages => {
          if (!TypeUtils.isNull(pages) && pages.length >= 2) {
          }
        });
    } else {
      this._store.select(fromStore.getWebsiteBoosterPages(websiteId))
        .pipe(
          distinctUntilChanged((oldPages: BoosterPage[], newPages: BoosterPage[]) => oldPages && newPages && oldPages.length === newPages.length),
          takeUntil(this._destroyStream$)
        )
        .subscribe(pages => {
          if (!TypeUtils.isNull(pages) && pages.length >= 2) {
          }
        });
    }
  }


  private _hostingAddOnDialogShow(): void {
    const modal = this._dbModalService.open(InformativeDialogComponent, {hasCloseBtn: true, backdrop: 'static'});
    modal.componentInstance.title = TextUtils.getText("text_hostingIsAvailableTitle");
    modal.componentInstance.eventAction = 'Introducing Hosting Add-on';
    modal.componentInstance.eventLabel = 'Hosting Add-on';
    modal.componentInstance.description = TextUtils.getText("text_hostingIsAvailableDesc");
    modal.componentInstance.button = {
      color: 'ds-btn-green',
      size: 'ds-btn-xl',
      text: TextUtils.getText("text_buyHosting"),
    };
    modal.componentInstance.features = this.hostingAddOnFeatures;
    modal.componentInstance.sizes = {height: 600, width: 940};
    modal.componentInstance.rightImage = "assets/images/backgrounds/hosting-features-dialog.png";
    modal.componentInstance.websiteId = this.website.id;

    modal.closed.subscribe(() => {
      const analyticsData = {
        eventCategory: 'Dashboard Action',
        eventAction: 'Buy now button (Introducing Hosting Add-on pop-up)',
        eventLabel: 'Hosting add-on',
        websiteId: this.website.id
      };
      this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
      this._dialogService.addDialog(PaymentDialogComponent, {
        upgradeSubscription: this.userSubscription,
        fromDialog: true,
        renew: false,
        showAdditional: true,
        fromHosting: true,
        extend: false,
        buyCdnAddOn: false,
        websiteId: this.website && this.website.id
      });
    });
  }

  private _checkBoosterPluginUpdateAvailable(): void {
    this._store.select(fromStore.getBoosterPluginInfo(this.website.id))
      .pipe(
        filter(pluginInfo => !!pluginInfo)
      )
      .subscribe(([pluginUpdateAvailable, currentVersion]) => {
        if (((!TypeUtils.isNull(pluginUpdateAvailable) && !!pluginUpdateAvailable) || (TypeUtils.isNull(pluginUpdateAvailable) && TypeUtils.isNull(currentVersion))) && !this.website.domain_hash) {
          this.seenUpdateDialog = true;
          const modal = this._dbModalService.open(UpdateBoosterPluginComponent);
          modal.componentInstance.websiteId = this.website && this.website.id;
          modal.componentInstance.companyName = this.companyName;
          modal.componentInstance.adminPluginsUrl = this.website && this.website.adminPluginsUrl;
          modal.componentInstance.websiteConnectedFrom = this.website && this.website.connectedFrom;
          modal.componentInstance.currentVersion = !TypeUtils.isNull(currentVersion) ? currentVersion : '';
        }
      });
  }

  private _showPercentOffer() {
    const percentOfferEndDate = new Date("2024-01-30 18:00:00").getTime();
    const datesDiff = Utils.getTimeDiffFromToday(percentOfferEndDate);
    this.showPercentOffer = datesDiff && this.userSubscription && this.userSubscription.trialBoosterClient;
  }

  private addEventHandlers(): void {
    this.addWebsiteSubscriptions();

    this._router.events
      .pipe(
        takeUntil(this._destroyStream$),
        filter(event => (
          event instanceof NavigationEnd && !event.url.includes('change-environment')
          && !!event.url.match(/websites\/[0-9]*/)
        )),
      )
      .subscribe(() => {
        this.routerLink = this._router.url;
        this.routeData = this._routeDataService.getCurrentRouteData();

        this._checkAndExpandAdvancedSection();
        this._checkAndExpandDropdowns();

        if (this.website && !this._router.url.match(`/websites\/${this.website.id}*/`)) {
          this.initData();
          if (this.website && this._prevWebsiteId !== this.website.id && this.routerLink.includes(String(this.website.id))) {
            this.removeWebsiteSubscriptions();
            this.addWebsiteSubscriptions();
          }
        }
      });

    // Listen for primary sidebar toggle changes and close website sidebar when primary opens
    this.sidebarNavigationService.isSidebarVisible
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe((primarySidebarVisible: boolean) => {
        if (primarySidebarVisible) {
          // Primary sidebar is opening, check if website sidebar is currently open and close it
          this._store.select(fromStore.getWebsiteSidebarToggled)
            .pipe(
              first()
            )
            .subscribe((websiteSidebarOpen: boolean) => {
              if (websiteSidebarOpen) {
                this._store.dispatch(new fromStore.ToggleWebsiteSidebar());
              }
            });
        }
      });

    this._actionEmitterService.actions$
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(action => {
        switch (action.name) {
          case 'changeEnv':
            this._router.navigate([`/websites/${this.website.id}/change-environment/live`], {
              queryParams: {manageEnv: true},
              skipLocationChange: true,
              replaceUrl: true
            });
            break;
        }
      });
  }

  private showExceededDialog() {
    if (this.currentWorkspaceId
      && ![clientRoles.SITE_DEV, clientRoles.COMPANY_DEV].includes(this.currentWorkspaceId)
      && this.userSubscription && this.userSubscription.recharge) {
      const modal = this._modalService.open(RechargeComponent, {height: 208, width: 700});
      modal.componentInstance.userSubscription = this.userSubscription;
      return;
    }
    let exceededDesc;
    let exceededBtnText = "text_upgrade";
    let exceededBtnColor = "green";
    let action = "upgrade";
    if (this.userRole && this.userRole === clientRoles.COMPANY_DEV) {
      action = "got it";
      exceededDesc = "text_domainsExceededContactOwner";
      exceededBtnText = "text_gotIt";
      exceededBtnColor = "blue";
    } else {
      switch (this.userSubscription.category) {
        case this.UserSubscriptionCategory.STARTER:
          exceededDesc = 'text_domainsExceededUpgradeToPaid';
          break;
        case this.UserSubscriptionCategory.PERSONAL:
        case this.UserSubscriptionCategory.PREMIUM:
          exceededDesc = 'text_hostedDomainsExceededDesc';
          break;
        case this.UserSubscriptionCategory.ENTERPRISE:
          exceededDesc = 'text_domainsExceededBuyAdditional';
          exceededBtnText = "text_buyNow";
          exceededBtnColor = 'blue';
          action = 'buyNow';
          break;
      }
    }

    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_domainsExceededTitleDialog'),
      message: TextUtils.getText(exceededDesc),
      buttonText: TextUtils.getText(exceededBtnText),
      buttonColor: exceededBtnColor,
      action: action,
      hasCloseButton: true
    })
      .subscribe((confirmed: string): void => {
        if (confirmed) {
          if (confirmed === 'upgrade') {
            this._router.navigate(['/upgrade-plan']);
          } else if (confirmed === 'buyNow') {
            this._dialogService
              .addDialog(PaymentDialogComponent, {
                upgradeSubscription: this.userSubscription,
                fromDialog: true,
                showAdditional: true
              });
          }
        }
      });
  }

  /**
   * Finds the currently active submenu item in the advanced section
   */
  private findActiveSubmenuItem(): Element | null {
    if (!this.advancedMenuRef || !this.advancedMenuRef.nativeElement) {
      return null;
    }

    const activeSubmenuItems = this.advancedMenuRef.nativeElement.querySelectorAll(
      '.db-website-sidebar__sub-menu_item_active, .db-website-sidebar__nav-menu_item_active'
    );

    return activeSubmenuItems.length > 0 ? activeSubmenuItems[0] : null;
  }

  private _getSidebarItems(): void {
    const hideCdnService = this.userSubscription && (([
        UserSubscriptionType.ONE_PRODUCT,
        UserSubscriptionType.PREMIUM,
      ].includes(this.userSubscription.type) && !this.website.domain_hash)
      || (this.userSubscription && this.userSubscription.plan && TypeUtils.isUndefined(this.userSubscription.plan.cdnService)));

    // Check for booster in both arrays
    let boosterIndex: number = this.sidebarItems?.findIndex(item => item.name === 'booster') ?? -1;
    let booster: WebsiteSidebarItem | WebsiteSidebarSubMenu = boosterIndex !== -1 && this.sidebarItems ? this.sidebarItems[boosterIndex] : null;
    let boosterInAdvanced = false;

    if (!booster) {
      boosterIndex = this.advancedSidebarItems?.findIndex(item => item.name === 'booster') ?? -1;
      booster = boosterIndex !== -1 && this.advancedSidebarItems ? this.advancedSidebarItems[boosterIndex] : null;
      boosterInAdvanced = true;
    }

    if (hideCdnService
      && this.userSubscription && !this.userSubscription.trialBoosterClient
      && !(this.userSubscription.platformPaidClient && (this.website.domain_hash || this.website.connectedFrom === 'speed_optimizer'))
      && !this.userSubscription.trialClient) {
      if (booster && booster instanceof WebsiteSidebarSubMenu) {
        booster.subMenu = booster.subMenu.filter(_item => _item.name !== 'cloudflare');
        if (boosterInAdvanced) {
          this.advancedSidebarItems[boosterIndex] = booster;
        } else {
          this.sidebarItems[boosterIndex] = booster;
        }
      }
    }
    if (!!this.website.domain_hash) {
      this.sidebarItems = this.sidebarItems && this.sidebarItems.length && this.sidebarItems.map(item => {
        if (item.name === 'domains' && !this.userSubscription?.hasActiveDomainAgreement) {
          item.beta = true;
        }
        return item;
      });
      this.advancedSidebarItems = this.advancedSidebarItems && this.advancedSidebarItems.length && this.advancedSidebarItems.map(item => {
        if (item.name === 'domains' && !this.userSubscription?.hasActiveDomainAgreement) {
          item.beta = true;
        }
        // Set showUpgrade for plugins and themes submenu items for vibe coding trial users
        if (this.website?.isWVC && this.userSubscription?.trialClient
            && item instanceof WebsiteSidebarSubMenu && item.subMenu) {
          item.subMenu = item.subMenu.map(subItem => {
            if (subItem.name === 'plugins' || subItem.name === 'themes') {
              subItem.showUpgrade = true;
            }
            return subItem;
          });
        }
        return item;
      });

      if (booster && booster instanceof WebsiteSidebarSubMenu) {
        booster.subMenu = booster.subMenu.filter(_item => _item.name !== 'hosting-performance' && _item.name !== 'backend');
        if (boosterInAdvanced) {
          this.advancedSidebarItems[boosterIndex] = booster;
        } else {
          this.sidebarItems[boosterIndex] = booster;
        }
      }

      if (this.website?.isWVC && this.userSubscription?.trialClient) {
        this.sidebarItems = this.sidebarItems.filter(item => item.name !== 'booster');
        this.advancedSidebarItems = this.advancedSidebarItems.filter(item => item.name !== 'booster');
      }
    } else {
      // Check for hosting in both arrays
      let hostingIndex: number = this.sidebarItems?.findIndex(item => item.name === 'hosting') ?? -1;
      let hosting: WebsiteSidebarSubMenu = hostingIndex !== -1 && this.sidebarItems ? <WebsiteSidebarSubMenu>this.sidebarItems[hostingIndex] : null;
      let hostingInAdvanced = false;

      if (!hosting) {
        hostingIndex = this.advancedSidebarItems?.findIndex(item => item.name === 'hosting') ?? -1;
        hosting = hostingIndex !== -1 && this.advancedSidebarItems ? <WebsiteSidebarSubMenu>this.advancedSidebarItems[hostingIndex] : null;
        hostingInAdvanced = true;
      }

      if (hosting && hosting instanceof WebsiteSidebarSubMenu) {
        hosting.subMenu = hosting.subMenu.filter(_item => _item.name !== 'hosting' && _item.name !== 'backend');
        if (hostingInAdvanced) {
          this.advancedSidebarItems[hostingIndex] = hosting;
        } else {
          this.sidebarItems[hostingIndex] = hosting;
        }
      }

      this.sidebarItems = this.sidebarItems.map(item => {
        if (item.name === 'domains') {
          item.hidden = true;
        }
        return item;
      });
      this.advancedSidebarItems = this.advancedSidebarItems.map(item => {
        if (item.name === 'domains') {
          item.hidden = true;
        }
        return item;
      });
    }

    if (!this.website.isNetwork && this.boosterPlugin && !this.boosterPlugin.active
      && this.user.oneProductOrBundleClient) {
      this.sidebarItems = this.sidebarItems.filter(item => item.name !== 'booster');
      this.advancedSidebarItems = this.advancedSidebarItems.filter(item => item.name !== 'booster');
    }

    if (!!this.website.domain_hash && !this.website.isNetwork && this.boosterPlugin && this.boosterPlugin.active) {
      this.sidebarItems = this.sidebarItems && this.sidebarItems.map(item => {
        if (item.name === 'boosterDisabled' && this.website.type === 'live') {
          return WebsiteSidebarSubMenuDirector.construct('booster');
        }
        if (item.name === 'hosting-performance') {
          item.hidden = true;
        }
        if (item.name === 'imageOptimizer') {
          item.hidden = true;
        }
        return item;
      });
      this.advancedSidebarItems = this.advancedSidebarItems && this.advancedSidebarItems.map(item => {
        if (item.name === 'boosterDisabled' && this.website.type === 'live') {
          return WebsiteSidebarSubMenuDirector.construct('booster');
        }
        if (item.name === 'hosting-performance') {
          item.hidden = true;
        }
        if (item.name === 'imageOptimizer') {
          item.hidden = true;
        }
        return item;
      });
    } else if (this.userSubscription && !this.website.domain_hash
      && [UserSubscriptionType.PREMIUM, UserSubscriptionType.ONE_PRODUCT].includes(this.userSubscription.type)
      && !this.website.isNetwork && (!this.boosterPlugin || (this.boosterPlugin && !this.boosterPlugin.active))) {
      this.sidebarItems = this.sidebarItems.map(item => {
        if (item.name === 'booster') {
          return WebsiteSidebarSubMenuDirector.construct('boosterDisconnected');
        }
        if (item.name === 'imageOptimizer') {
          item.hidden = false;
        }
        return item;
      });
      this.advancedSidebarItems = this.advancedSidebarItems.map(item => {
        if (item.name === 'booster') {
          return WebsiteSidebarSubMenuDirector.construct('boosterDisconnected');
        }
        if (item.name === 'imageOptimizer') {
          item.hidden = false;
        }
        return item;
      });
    } else if (this.userSubscription && !!this.website.domain_hash && !this.website.isNetwork && (!this.boosterPlugin || (this.boosterPlugin && !this.boosterPlugin.active))) {
      this.sidebarItems = this.sidebarItems.map(item => {
        if (item.name === 'booster' && this.website.type === 'live') {
          return WebsiteSidebarSubMenuDirector.construct('boosterDisabled');

        } else if (item.name === 'boosterDev' && this.website.type !== 'live') {
          return WebsiteSidebarSubMenuDirector.construct('boosterDisabledDev');

        }
        if (item.name === 'imageOptimizer') {
          item.hidden = true;
        }
        return item;
      });
      this.advancedSidebarItems = this.advancedSidebarItems.map(item => {
        if (item.name === 'booster' && this.website.type === 'live') {
          return WebsiteSidebarSubMenuDirector.construct('boosterDisabled');

        } else if (item.name === 'boosterDev' && this.website.type !== 'live') {
          return WebsiteSidebarSubMenuDirector.construct('boosterDisabledDev');

        }
        if (item.name === 'imageOptimizer') {
          item.hidden = true;
        }
        return item;
      });

      // Check for hosting in both arrays
      let hostingIndex2: number = this.sidebarItems?.findIndex(item => item.name === 'hosting') ?? -1;
      let hosting2: WebsiteSidebarSubMenu = hostingIndex2 !== -1 && this.sidebarItems ? <WebsiteSidebarSubMenu>this.sidebarItems[hostingIndex2] : null;
      let hosting2InAdvanced = false;

      if (!hosting2) {
        hostingIndex2 = this.advancedSidebarItems?.findIndex(item => item.name === 'hosting') ?? -1;
        hosting2 = hostingIndex2 !== -1 && this.advancedSidebarItems ? <WebsiteSidebarSubMenu>this.advancedSidebarItems[hostingIndex2] : null;
        hosting2InAdvanced = true;
      }

      if (hosting2 && hosting2 instanceof WebsiteSidebarSubMenu) {
        hosting2.subMenu = hosting2.subMenu.filter(_item => _item.name !== 'hosting-performance');
        if (hosting2InAdvanced) {
          this.advancedSidebarItems[hostingIndex2] = hosting2;
        } else {
          this.sidebarItems[hostingIndex2] = hosting2;
        }
      }
      // Hide booster for vibe coding trial users
      if ((+this.userSubscription?.product_id === Config.vibeCodingPluginId) && this.userSubscription?.trialClient) {
        this.sidebarItems = this.sidebarItems.filter(item => item.name !== 'booster');
        this.advancedSidebarItems = this.advancedSidebarItems.filter(item => item.name !== 'booster');
      }

    }

    if (!!this.woocommercePlugin && this.woocommercePlugin.active
      && this.userSubscription && ((this.userSubscription.platformPaidClient && this.userSubscription.plan
        && this.userSubscription.plan.woocommerceService) || (this.website.isEcommerceWebsite && this.userSubscription.isEcommerce)
        || this.userSubscription.trialClient)) {
      this.sidebarItems = this.sidebarItems && this.sidebarItems.map(item => {
        if (item.name === 'ecommerce') {
          return WebsiteSidebarSubMenuDirector.construct('ecommerceActive');
        }
        return item;
      });
      this.advancedSidebarItems = this.advancedSidebarItems && this.advancedSidebarItems.map(item => {
        if (item.name === 'ecommerce') {
          return WebsiteSidebarSubMenuDirector.construct('ecommerceActive');
        }
        return item;
      });
    } else {
      this.sidebarItems = this.sidebarItems && this.sidebarItems.map(item => {
        if (item.name === 'ecommerce') {
          return WebsiteSidebarSimpleItemDirector.construct('ecommerce');
        }
        return item;
      });
      this.advancedSidebarItems = this.advancedSidebarItems && this.advancedSidebarItems.map(item => {
        if (item.name === 'ecommerce') {
          return WebsiteSidebarSimpleItemDirector.construct('ecommerce');
        }
        return item;
      });
    }

    if ((this.website.isNetwork && !this.website.parentId) || this.website.domain_hash) {
      if (!!this.seoPlugin && this.seoPlugin.active && this.seoPlugin.paidVersionInstalled) {
        const seoItemExists = this.sidebarItems.some(item => item.name === 'seo');
        const seoItemExistsAdv = this.advancedSidebarItems.some(item => item.name === 'seo');

        if (!seoItemExists && !seoItemExistsAdv) {
          const newItem = WebsiteSidebarSimpleItemDirector.construct('seo');
          this.sidebarItems.splice(this.sidebarItems.length - 1, 0, newItem);
        }
      } else {
        this.sidebarItems = this.sidebarItems.map(item => {
          if (item.name === 'seo') {
            item.hidden = true;
          }
          return item;
        });
        this.advancedSidebarItems = this.advancedSidebarItems.map(item => {
          if (item.name === 'seo') {
            item.hidden = true;
          }
          return item;
        });
      }
    }

    if (TypeUtils.isUndefined(this.userSubscription.plan.services.cloudflare_cdn) && this.userSubscription && !this.userSubscription.trialBoosterClient && !(this.userSubscription.platformPaidClient && (this.website.domain_hash || this.website.connectedFrom === 'speed_optimizer')) && !this.userSubscription.trialClient) {
      // Check for booster in both arrays
      let boosterIndex3: number = this.sidebarItems?.findIndex(item => item.name === 'booster') ?? -1;
      let booster3: WebsiteSidebarItem | WebsiteSidebarSubMenu = boosterIndex3 !== -1 && this.sidebarItems ? this.sidebarItems[boosterIndex3] : null;
      let booster3InAdvanced = false;

      if (!booster3) {
        boosterIndex3 = this.advancedSidebarItems?.findIndex(item => item.name === 'booster') ?? -1;
        booster3 = boosterIndex3 !== -1 && this.advancedSidebarItems ? this.advancedSidebarItems[boosterIndex3] : null;
        booster3InAdvanced = true;
      }

      if (booster3 && booster3 instanceof WebsiteSidebarSubMenu) {
        booster3.subMenu = booster3.subMenu.filter(_item => _item.name !== 'cloudflare');
        if (booster3InAdvanced) {
          this.advancedSidebarItems[boosterIndex3] = booster3;
        } else {
          this.sidebarItems[boosterIndex3] = booster3;
        }
      }
    }

    // Check if advanced section should be expanded after sidebar items are processed
    this._checkAndExpandAdvancedSection();
    // Check if dropdowns should be expanded after sidebar items are processed
    this._checkAndExpandDropdowns();
  }

  private addWebsiteSubscriptions(): void {
    this._websiteSubscriptions = [];

    this._websiteSubscriptions.push(
      this._store.select(fromStore.getWebsitesLoaded)
        .pipe(
          filter(loaded => !!loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getWebsite(this.website.parentId)),
            this._store.select(fromStore.getWebsites),
            this._store.select(fromStore.getWebsite(this.website.id)),
          )),
          filter(([, , currWebsite]) => !!currWebsite)
        )
        .subscribe(([parentWebsite, websites, currWebsite]) => {
          this.website = currWebsite;
          this.primaryChanged = !Utils.checkStringInArray(this.website.site_url, Config.hostnameList);
          this.parentWebsite = parentWebsite || null;
          this.networkSubSites = websites.filter((website: Website) => (website.type === 'live' && website.isNetwork && website.parentId && this.website && website.parentId === this.website.parentId && website.id !== this.website.id));
          this.hostedWebsite = websites.find((website: Website) => !website.parentId && !website.isNetwork && website.isActive && website.type === 'live' && !!website.domain_hash);
          this.hostedWebsiteCount = websites.find((website: Website) => !website.parentId && !website.isNetwork && website.isActive && website.type === 'live' && !!website.domain_hash);

        })
    );

    this._websiteSubscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getWorkspaceIdEntities),
            this._store.select(fromStore.getUserSubscriptionState),
            this._store.select(fromStore.getCurrentWorkspace)),
          ),
          filter(([user, userSubscription]) => !!user && !!userSubscription),
          takeUntil(this._destroyStream$)
        )
        .subscribe(([userSubscription, workspaceIdEntities, userSubscriptionState, currentWorkspace]) => {
          this.userSubscription = userSubscription;
          this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || workspaceIdEntities.ownerWorkspaceId;
          this.userRole = this.user && this.user.workspaces.find(el => el.workspaceId === this.currentWorkspaceId);

          this.renderSidebar();
          /** filter whiteLabel for contr & members */
          if (this.userRole && this.sidebarItems && [clientRoles.COMPANY_DEV, clientRoles.SITE_DEV].includes(this.userRole.roleId)) {
            this.sidebarItems = this.sidebarItems.filter(item => item.name !== 'whiteLabel');
          }
          if (userSubscriptionState && this.user && (userSubscriptionState.noActiveSubscription || userSubscriptionState.subscriptionExpired) && !this.redirectionCompleted) {
            if (currentWorkspace && !['invited'].includes(currentWorkspace.status)) {
              this._router.navigate(['/workspace/subscription-plan']);
              this.redirectionCompleted = true;
              return;
            }
          }
        })
    );

    this._websiteSubscriptions.push(
      this._store.select(fromStore.getWebsitePluginsLoaded(this.website?.id))
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getWebsiteBuilderPlugin(this.website.id)),
            this._store.select(fromStore.getWebsiteOptimizerPlugin(this.website.id)),
            this._store.select(fromStore.getWebsiteWoocommercePlugin(this.website.id)),
            this._store.select(fromStore.getWebsiteSeoPlugin(this.website.id))
          )),
          takeUntil(this._destroyStream$)
        )
        .subscribe(([, boosterPlugin, woocommercePlugin, seoPlugin]) => {
          this.boosterPlugin = boosterPlugin;
          this.woocommercePlugin = woocommercePlugin;
          this.seoPlugin = seoPlugin;
          this._updateCloudflareState();
          this._getSidebarItems();
        })
    );

    this._websiteSubscriptions.push(
      this._store.select(fromStore.getEnableDevEnvironmentOngoingActivity(this.website?.id))
        .pipe(
          filter((ongoingActivity: IActivity) => ongoingActivity && ongoingActivity.status === ActivityStatus.DONE),
          switchMap(() => this._store.select(fromStore.getWebsite(this.website?.id)))
        )
        .subscribe((website: Website) => {
          this._prevWebsiteId = this.website && this.website.id || null;
          this.website = website;
        })
    );

    this._websiteSubscriptions.push(
      this._store.select(fromStore.getOngoingActivities)
        .subscribe((data): void => {
          if (data) {
            const ongoingActivitiesDone = data.filter((activity): any => activity && activity.meta && activity.meta.product_data && activity.meta.product_data.slug && activity.meta.product_data.slug === Config.builderPluginSlug && (activity.status === ActivityStatus.DONE || activity.status === ActivityStatus.FAILED));
            if (ongoingActivitiesDone.length) {
              this.renderSidebar();
              this._getSidebarItems();
            }
          }
        })
    );

    this._websiteSubscriptions.push(
      this._store.select(fromStore.getDomains(this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id))
        .pipe(
          takeUntil(this._destroyStream$)
        )
        .subscribe((domains: HostingDomainData[]) => {
          this._updateCloudflareState();
          this.domains = domains;
          this._updateDomainState();


        })
    );

    this._websiteSubscriptions.push(
      this._store.select(fromStore.getInfoLoaded(this.website?.id))
        .pipe(
          filter((loaded: boolean) => !!loaded),
          switchMap(() => this._store.select(fromStore.getInfo(this.website?.id))),
        )
        .subscribe((hostingInfo: any): void => {
          if (hostingInfo) {
            this.passwordProtection = hostingInfo && hostingInfo.hostingPasswordProtection;
          }
        })
    );
    const _agreementDayDiff = Utils.getDaysDiffFromToday(this.userSubscription?.agreementDate, false);
    if (this.user && this.userSubscription && this.hostedWebsite && !this.hostedWebsite?.isAiBuilderDemo && ((!this.user.hostingTrialExpired && this.userSubscription.trialClient) || (this.userSubscription && this.userSubscription.platformPaidClient && +_agreementDayDiff < 8) || (this.user && this.user.isSuspected))) {
       this._hostingService.whiteListIp(this.hostedWebsite.id, this.hostedWebsite.site_url);
    }
  }

  private removeWebsiteSubscriptions(): void {
    if (this._websiteSubscriptions) {
      this._websiteSubscriptions.forEach((subscription: Subscription) => {
        subscription.unsubscribe();
      });
      this._websiteSubscriptions = null;
    }
  }

  private initData(): void {
    const routerData = this._routeDataService.getRouteDatas()[0] && this._routeDataService.getRouteDatas()[0].data;
    if (routerData) {
      this._prevWebsiteId = this.website && this.website.id || null;
      this.website = routerData.website;
      this.websiteSettings = routerData.websiteSettings;
      this.user = routerData.user;
      this.fromGallery = this.user && Config.photoGalleryPluginIds.includes(this.user?.connectedFromProductId.toString());
      this.userLocalStorage = routerData.userLocalStorage;
      this.agencyOrFreelancer = this.user?.agencyOrFreelancer;
      if (this.user && this.userSubscription && this.userSubscription.subscriptionId === this.userSubscriptionIds.TRIAL
        && this.agencyOrFreelancer && !localStorage.getItem('dbDeveloper') && !!this.website.isMigrated) {
        this.showTour = !this.userLocalStorage || (this.userLocalStorage && !this.userLocalStorage['dbHideTour']);
        this.showTour && this.onToggleClick.emit(true);
      }
    }
  }

  private renderSidebar(): void {
    if (!this.website) {
      return;
    }

    let websiteSidebarListType: WebsiteSidebarListFactoryType;

    if (this.website.isNetwork) {
      if (!this.website.parentId) {
        websiteSidebarListType = this.website.multisiteType === 'subdomain' ? 'networkParentSubDomain' : 'networkParentSubFolder';
      } else {
        websiteSidebarListType = this.website.multisiteType === 'subdomain' ? 'networkChildSubDomain' : 'networkChildSubFolder';
      }
    } else {
      if (this.website.type === 'live') {
        websiteSidebarListType = this.websiteSettings && Utils.isTruthy(this.websiteSettings.staging_enabled) ? 'hostedLiveStagingEnabled' : 'hostedLive';
      } else {
        websiteSidebarListType = 'hostedDev';
      }
    }

    const allItems = WebsiteSidebarListFactory.create(websiteSidebarListType);

    // For agency users, show all items in the main sidebar
    // For non-agency users, separate into regular and advanced items
      // Basic filtering for advanced items
    this.sidebarItems = allItems.filter(item => !item?.advanced);
    this.advancedSidebarItems = allItems.filter(item => !!item?.advanced);

    if (!this.website.parentId && this.website.domain_hash && this.userSubscription && [this.UserSubscriptionCategory.PROFESSIONAl, UserSubscriptionCategory.ENTERPRISE_ULTIMATE].includes(this.userSubscription.category)) {
      const newItem = WebsiteSidebarSimpleItemDirector.construct('professional');

      // Specify the index where you want to insert the item (e.g., 0 for the first position)
      const insertIndex = 5;

      // Use splice to insert the item at the specified index
      this.sidebarItems.splice(insertIndex, 0, newItem);
    }

    if (this.userSubscription && this.userSubscription.plan.services && !this.userSubscription.plan.services.speed_optimizer) {
      this.sidebarItems = this.sidebarItems.filter(item => item.name !== 'booster');
    }

    if ((this.userSubscription && !this.userSubscription.newPlan) && (this.website && !this.website.isEcommerceWebsite)) {
      this.sidebarItems = this.sidebarItems.filter(item => item.name !== 'ecommerce');
    }

    if (!this.website.domain_hash) {
      if ([this.userSubscriptionTypes.ONE_PRODUCT, this.userSubscriptionTypes.PREMIUM].includes(this.userSubscription.type)) {
        if (this.userSubscription && this.userSubscription.plan.services.speed_optimizer) {
          this.sidebarItems = WebsiteSidebarListFactory.create('oneProductOrBundleConnectedWithBooster');

        } else {
          this.sidebarItems = WebsiteSidebarListFactory.create('oneProductOrBundleConnected');
        }
        // return;
      }

      if (([this.userSubscriptionTypes.PLATFORM, this.userSubscriptionTypes.DEDICATEDVM].includes(this.userSubscription.type) && this.website.type === 'live')
        || (this.userSubscription.boosterProClient && this.website.domain_hash && this.website.type === 'live')) {
        this.sidebarItems = WebsiteSidebarListFactory.create('boosterConnected');
        // return;
      }

      if (this.userSubscription && (this.userSubscription.trialBoosterClient ||
        (this.userSubscription.boosterProClient && this.website.type === 'live'))) {
        this.sidebarItems = WebsiteSidebarListFactory.create('boosterOnly');
        // return;
      }

      this.sidebarItems = this.sidebarItems.filter(item => {
        if (item.name !== 'hosting' && item.name !== 'whiteLabel') {
          return item;
        }
      });
    } else if (!this.website.domain_hash && (this.userSubscription.type === this.userSubscriptionTypes.TENWEBX_LTD
      || this.userSubscription.type === this.userSubscriptionTypes.TENWEBX_RECURRING)) {
      this.sidebarItems = this.sidebarItems.filter(item => {
        if (['main', 'builderEnabled', 'builder', 'plugins', 'themes'].includes(item.name)) {
          return item;
        }
      });
    }

    this._websiteSubscriptions.push(
      this._updateCloudflareState(),
    );

    // Check if advanced section should be expanded after sidebar is rendered
    this._checkAndExpandAdvancedSection();
    // Check if dropdowns should be expanded after sidebar is rendered
    this._checkAndExpandDropdowns();
  }


  private _updateCloudflareState(): Subscription {
    return this._store.select(fromStore.getCloudflareData(this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$),
      )
      .subscribe(data => {
        // Check for booster in both arrays
        let boosterSubmenu: WebsiteSidebarSubMenu = this.sidebarItems?.find(({name}) => name === 'booster') as WebsiteSidebarSubMenu;
        let boosterInAdvanced = false;

        if (!boosterSubmenu) {
          boosterSubmenu = this.advancedSidebarItems?.find(({name}) => name === 'booster') as WebsiteSidebarSubMenu;
          boosterInAdvanced = true;
        }

        if (!boosterSubmenu) return;
        const cloudflare = boosterSubmenu.subMenu?.find(({name}) => name === 'cloudflare');
        if (!cloudflare) return;
        cloudflare.notification = TypeUtils.isEmpty(data) || (data && data.cfStatus === 'pending');

        const cloudflareIndex: number = boosterInAdvanced
          ? this.advancedSidebarItems?.findIndex(item => item.name === 'cloudflare') ?? -1
          : this.sidebarItems?.findIndex(item => item.name === 'cloudflare') ?? -1;

        if (cloudflareIndex !== -1) {
          if (boosterInAdvanced) {
            this.advancedSidebarItems[cloudflareIndex] = cloudflare;
          } else {
            this.sidebarItems[cloudflareIndex] = cloudflare;
          }
        }
      });
  }

  private _updateDomainState(): Subscription {
    // Check for domains in both arrays
    let domainMenu: WebsiteSidebarItem = this.sidebarItems?.find(({name}) => name === 'domains') as WebsiteSidebarItem;

    if (!domainMenu) {
      domainMenu = this.advancedSidebarItems?.find(({name}) => name === 'domains') as WebsiteSidebarItem;
    }

    if (!domainMenu) return;
    domainMenu.notification = !!(!this.primaryChanged || (!this.primaryChanged && this.domains.length > 1));
  }

  /**
   * Checks if any advanced sidebar items are active and expands the advanced section if needed
   */
  private _checkAndExpandAdvancedSection(): void {
    if (!this.advancedSidebarItems || !this.website || !this.routerLink) {
      return;
    }

    // Check if any advanced items are active
    const hasActiveAdvancedItem = this.advancedSidebarItems.some(item => {
      if (item.hidden) {
        return false;
      }

      // Check simple items
      if (item.type === 'simple' && 'path' in item && item.path) {
        return this.routerLink.includes(`/websites/${this.website.id}${item.path}`);
      }

      // Check dropdown/accordion items with submenus
      if ((item.type === 'dropdown' || item.type === 'accordion' || item.type === 'static') && 'subMenu' in item && item.subMenu) {
        return item.subMenu.some(subItem => {
          if (subItem.path) {
            return this.routerLink.includes(`/websites/${this.website.id}${subItem.path}`);
          }
          return false;
        });
      }

      return false;
    });

    // Expand advanced section if any item is active
    if (hasActiveAdvancedItem) {
      this.showAdvanced = true;

      // Auto-scroll to the active item after a short delay to ensure DOM is rendered
      setTimeout(() => {
        const activeSubmenuItem = this.findActiveSubmenuItem();
        if (activeSubmenuItem) {
          activeSubmenuItem.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          });
        }
      }, 200);
    }
  }

  /**
   * Checks dropdown items and auto-expands them if they contain active submenu items
   */
  private _checkAndExpandDropdowns(): void {
    if (!this.website || !this.routerLink) {
      return;
    }

    // Process main sidebar dropdowns
    this._expandDropdownsInArray(this.sidebarItems);

    // Process advanced sidebar dropdowns
    this._expandDropdownsInArray(this.advancedSidebarItems);
  }

  /**
   * Helper method to expand dropdowns in a given array that contain active items
   */
  private _expandDropdownsInArray(items: any[]): void {
    if (!items) {
      return;
    }

    items.forEach(item => {
      if (item.hidden || item.type !== 'dropdown') {
        return;
      }

      // Check if this dropdown contains active submenu items
      if ('subMenu' in item && item.subMenu) {
        const hasActiveSubItem = item.subMenu.some(subItem => {
          if (subItem.path) {
            return this.routerLink.includes(`/websites/${this.website.id}${subItem.path}`);
          }
          return false;
        });

        // Auto-expand if it contains active items, but don't override manual user interaction
        if (hasActiveSubItem && !item.isExpanded) {
          item.isExpanded = true;
        }
      }
    });
  }

}
